/**
 * Created by razial on 17.01.2021
 */

const UnitsLibrary = function (locationConfig) {
    this.locationConfig = locationConfig;

    const stored = this.locationConfig.slot.load("unitslibrary");
    this.load(stored);
    this.logEvents();
};

UnitsLibrary.prototype.load = function (stored) {
    stored = stored || {};
    stored.opened = stored.opened || {};
    stored.fresh = stored.fresh || {};

    this.opened = cleverapps.listFromBit(stored.opened);
    this.fresh = cleverapps.listFromBit(stored.fresh);

    this.processUnknown();
};

UnitsLibrary.prototype.logEvents = function () {
    const sideQuestsLines = Families.listSideQuestsLines();
    if (sideQuestsLines.every((line) => this.getLastOpenStage(line) === UnitsLibrary.LastStage(line).stage)) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_SIDEQUESTS);
    }

    Object.keys(this.opened).forEach((code) => {
        const stage = this.getLastOpenStage(code);
        if (stage !== undefined) {
            cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.OPEN_STAGE}_${code}_${stage}`);
        }
    });
};

UnitsLibrary.prototype.save = function (fromServer) {
    this.locationConfig.slot.save("unitslibrary", this.getInfo(), fromServer);
};

UnitsLibrary.prototype.processUnknown = function () {
    this.unknownOpened = {};
    this.unknownFresh = {};

    Object.keys(this.opened).forEach(function (code) {
        if (Families[code] && !this.isHidden({ code })) {
            return;
        }
        if (!Families[code]) {
            this.unknownOpened[code] = this.opened[code];
            if (this.fresh[code] !== undefined) {
                this.unknownFresh[code] = this.fresh[code];
            }
        }
        delete this.opened[code];
        delete this.fresh[code];
    }, this);

    for (const code in this.fresh) {
        Object.keys(this.fresh[code]).forEach(function (stage) {
            if (this.isHiddenFresh({ code, stage })) {
                delete this.fresh[code][stage];
            }
        }, this);
    }

    Families.codes.forEach((code) => {
        if (!this.opened[code]) {
            delete this.opened[code];
            delete this.fresh[code];
        }

        if (!this.fresh[code]) {
            delete this.fresh[code];
        }
    });
};

UnitsLibrary.prototype.getInfo = function () {
    return {
        opened: { ...cleverapps.listToBit(this.opened), ...this.unknownOpened },
        fresh: { ...cleverapps.listToBit(this.fresh), ...this.unknownFresh }
    };
};

UnitsLibrary.prototype.reset = function () {
    this.opened = {};
    this.fresh = {};
    this.unknownOpened = {};
    this.unknownFresh = {};
    this.save();
};

UnitsLibrary.prototype.resetFamilies = function (codes) {
    codes = cleverapps.toArray(codes);

    codes.forEach(function (code) {
        delete this.opened[code];
        delete this.fresh[code];
    }, this);

    this.save();
};

UnitsLibrary.prototype.resetUnit = function (unit) {
    if (this.opened[unit.code]) {
        delete this.opened[unit.code][unit.stage];
    }

    if (this.fresh[unit.code]) {
        delete this.fresh[unit.code][unit.stage];
    }

    this.save();
};

UnitsLibrary.LastStage = function (code) {
    const units = Families[code].units;
    for (let id = units.length - 1; id >= 0; id--) {
        if (!units[id].temporary) {
            return {
                code,
                stage: id
            };
        }
    }
};

UnitsLibrary.ListByCode = function (code) {
    const units = Families[code].units;
    const res = [];
    for (let id = 0; id < units.length; id++) {
        if (!units[id].temporary) {
            res.push({
                code,
                stage: id,
                unmergeable: units[id].unmergeable
            });
        }
    }
    return res;
};

UnitsLibrary.prototype.listOpenedPlusOneWithUnknown = function (code) {
    let units = UnitsLibrary.ListByCode(code);

    if (["advsource", "advprize"].indexOf(Families[code].type) !== -1) {
        units = units.filter((unit) => this.isOpened(unit) || Map2d.currentMap.fogs.isPresentOnMap(unit));
    }

    for (let i = units.length - 1; i >= 1; i--) {
        if (this.isOpened(units[i]) || this.isOpened(units[i - 1])) {
            break;
        }

        units[i].unknown = true;
    }

    if (units.length > 0) {
        units[units.length - 1].last = true;
    }

    return units;
};

UnitsLibrary.prototype.isOpened = function (unit) {
    return this.opened[unit.code] && this.opened[unit.code][unit.stage];
};

UnitsLibrary.prototype.isFresh = function (unit) {
    return this.fresh[unit.code] && this.fresh[unit.code][unit.stage] !== undefined;
};

UnitsLibrary.prototype.openUnit = function (unit) {
    if (unit instanceof Unit && unit.findComponent(Grounded)) {
        return;
    }

    if (!this.isOpened(unit) && !this.isHidden(unit)) {
        if (!this.opened[unit.code]) {
            this.opened[unit.code] = {};
        }

        this.opened[unit.code][unit.stage] = true;

        if (!this.isHiddenFresh(unit)) {
            if (!this.fresh[unit.code]) {
                this.fresh[unit.code] = {};
            }

            this.fresh[unit.code][unit.stage] = true;
        }

        cleverapps.eventBus.trigger("unitOpened", unit);
        cleverapps.eventBus.trigger("unitStatusChanged", unit);

        cleverapps.toolbar.resetByType(ToolbarItem.UNITS_LIBRARY);

        this.save();

        return true;
    }
};

UnitsLibrary.prototype.isHidden = function (unit) {
    return UnitsLibrary.HIDDEN_CODES.indexOf(unit.code) !== -1
        || UnitsLibrary.HIDDEN_TYPES.indexOf(Families[unit.code].type) !== -1;
};

UnitsLibrary.prototype.isHiddenFresh = function (unit) {
    const family = Families[unit.code];
    const data = family.units[unit.stage];

    if (data === undefined) {
        console.log("UNIT", unit.code, unit.stage);
        return false;
    }

    return this.isHidden(unit)
        || UnitsLibrary.HIDDEN_FRESH_CODES.indexOf(unit.code) !== -1 || data.temporary
        || UnitsLibrary.HIDDEN_FRESH_TYPES.indexOf(family.type) !== -1;
};

UnitsLibrary.prototype.removeFresh = function (unit, source) {
    if (this.fresh[unit.code][unit.stage]) {
        delete this.fresh[unit.code][unit.stage];

        this.addReward(unit, source);

        cleverapps.eventBus.trigger("unitStatusChanged", unit);

        cleverapps.toolbar.resetByType(ToolbarItem.UNITS_LIBRARY);

        this.save();
    }
};

UnitsLibrary.prototype.addReward = function (unit, source) {
    Merge2.current.addReward("hard", 1, source, {
        withoutDelta: true,
        event: cleverapps.EVENTS.EARN.LIBRARY
    });
};

UnitsLibrary.prototype.hasOpened = function (code) {
    return Object.keys(this.opened[code] || {}).length > 0;
};

UnitsLibrary.prototype.hasFresh = function (code) {
    return Object.keys(this.fresh[code] || {}).length > 0;
};

UnitsLibrary.prototype.listAvailableByType = function (type) {
    return this.listCodesByType(type).filter(function (code) {
        return this.hasOpened(code);
    }, this);
};

UnitsLibrary.prototype.listOpenedOfType = function (type) {
    return this.listCodesByType(type).filter(function (code) {
        return this.hasOpened(code);
    }, this);
};

UnitsLibrary.prototype.listCodesByType = function (types, locationId) {
    if (Array.isArray(types)) {
        return types.reduce((res, type) => res.concat(this.listCodesByType(type)), []);
    }
    let codesByType = (UnitsLibrary.codesByType[types] || []).slice();

    const families = locationId ? Families.listExpeditionCodes(locationId) : cleverapps.meta.getSelectedLocation().families;
    if (families) {
        codesByType = codesByType.filter((code) => families[code]);
    }

    return codesByType;
};

UnitsLibrary.prototype.listOpened = function (code) {
    return UnitsLibrary.ListByCode(code).filter(this.isOpened.bind(this));
};

UnitsLibrary.prototype.getFamilyName = function (code) {
    return Messages.get(`Units.${code}.name`) || `${code} family`;
};

UnitsLibrary.prototype.getUnitName = function (unit) {
    const key = `Units.${unit.code}.stage${unit.stage + 1}.name`;
    const fallbackName = `${unit.code} stage ${unit.stage + 1}`;

    return Messages.get(key) || fallbackName;
};

UnitsLibrary.prototype.hasAnyFresh = function (codes) {
    return codes.some(this.hasFresh.bind(this));
};

UnitsLibrary.prototype.calcRewardCoins = function (unit) {
    return Math.round(3 * Math.pow(1.3, unit.stage));
};

UnitsLibrary.prototype.getLastOpenStage = function (code) {
    const units = Families[code].units;

    for (let stage = units.length - 1; stage >= 0; stage--) {
        if (this.isOpened({ code, stage })) {
            return stage;
        }
    }

    return undefined;
};

UnitsLibrary.prototype.findFreshUnit = function (units) {
    for (let i = 0; i < units.length; ++i) {
        const unit = units[i];
        if (unit.code && (unit.stage === undefined && this.hasFresh(unit.code) || this.isFresh(unit))) {
            return unit;
        }
    }
};

UnitsLibrary.prototype.findLastOpenedUnit = function (units) {
    for (let i = units.length - 1; i >= 0; --i) {
        const unit = units[i];
        if (unit.code && this.isOpened(unit)) {
            return unit;
        }
    }
};

UnitsLibrary.prototype.listTabCodes = function (locationId, tabId) {
    const codesById = cleverapps.clone(UnitsLibrary.codesByTabId[locationId] || UnitsLibrary.codesByTabId.main, true);

    return codesById[tabId] || codesById.reduce((totalCodes, tabCodes) => totalCodes.concat(tabCodes), []);
};

UnitsLibrary.Init = function () {
    this.codesByType = {};
    const boosterTypes = [];

    Families.codes.forEach(function (code) {
        const type = Families[code].type;

        if (!this.codesByType[type]) {
            this.codesByType[type] = [];
        }

        this.codesByType[type].push(code);

        if (Families[code].booster && !boosterTypes.includes(type)) {
            boosterTypes.push(type);
        }
    }, this);

    this.codesByTabId = {};
    this.codesByTabId.main = [
        [],
        ["resource"],
        [],
        ["source", "generator"],
        ["energycup", "chooseline"],
        ["valuables", "custom"],
        boosterTypes
    ];

    const allLocations = [...new Set(Families.codes.map(
        (code) => Families[code].expeditions || []
    ).reduce((a, b) => a.concat(b), []).filter(cleverapps.isNumber).map(Number))];

    allLocations.forEach((location) => {
        this.codesByTabId[location] = this.codesByTabId.main;
    });

    Object.keys(this.codesByTabId).forEach(function (locationId) {
        const families = Families.listExpeditionCodes(cleverapps.isNumber(locationId) ? parseInt(locationId) : locationId);

        this.codesByTabId[locationId] = this.codesByTabId[locationId].map(function (types) {
            types = cleverapps.substract(types, UnitsLibrary.HIDDEN_TYPES);
            types = cleverapps.substract(types, UnitsLibrary.HIDDEN_FRESH_TYPES);

            let codes = types.reduce((total, type) => {
                if (families[type]) {
                    return total.concat(type);
                }

                if (this.codesByType[type]) {
                    return total.concat(this.codesByType[type].filter((code) => families[code]));
                }

                return total;
            }, []);
            codes = cleverapps.substract(codes, UnitsLibrary.HIDDEN_CODES);
            codes = cleverapps.substract(codes, UnitsLibrary.HIDDEN_FRESH_CODES);
            return codes;
        }, this);
    }, this);
};

UnitsLibrary.HIDDEN_CODES = ["thirdelement"];
UnitsLibrary.HIDDEN_TYPES = [];

UnitsLibrary.HIDDEN_FRESH_CODES = [];
UnitsLibrary.HIDDEN_FRESH_TYPES = [];

if (typeof cc === "undefined") {
    module.exports = UnitsLibrary;
}
